import { Box, Flex, Grid, GridItem, Image, Input, Text, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, FormControl, FormLabel, Button, Tooltip, IconButton, ModalOverlay, Modal, ModalBody, ModalHeader, ModalContent, ModalCloseButton, Tabs, TabList, TabPanels, Tab, TabPanel, Select } from '@chakra-ui/react'
import { EditIcon, AddIcon } from '@chakra-ui/icons';
import { CustomButton, CustomToast } from '../../../../components';
import { useEffect, useState } from 'react';
import PlusIcon from "../../../../assets/images/Vector.svg";
import { useFetch } from '../../../../hooks/useFetch';
import MyDiv from './documentCategory.style';
import { IDocumentCategory } from './model';
import DocumentName from './DocumentName';
import CustomTables, { Column, ILazyParams } from "../../../../components/CustomTable/CustomTables";

export interface IDocumentName {
    id: number;
    document_Category_Name: string;
    document_Name_Title: string;
    country: string;
    expire: boolean;
    document_Number: string;
    country_Name: string;
}

type DocumentForType = 'Employee' | 'Director';

const defaultLazyParams = (): ILazyParams => ({
    first: 0, rows: 20, sortField: undefined, sortOrder: undefined,
    multiSortMeta: [], filters: {}, globalFilter: '',
});

const MasterDepartment = () => {
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);

    const tabTypes: DocumentForType[] = ['Employee', 'Director'];
    const [activeTab, setActiveTab] = useState(0);
    const activeType = tabTypes[activeTab];

    const [DrawerOpen, setDrawerOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [currentDocumentCategory, setCurrentDocumentCategory] = useState<{
        id: number;
        document_Category_Name: string;
        document_For: DocumentForType;
    }>({ id: 0, document_Category_Name: '', document_For: 'Employee' });

    const [documentDrawerOpen, setDocumentDrawerOpen] = useState(false);
    const [selectedCategoryForDocument, setSelectedCategoryForDocument] = useState<IDocumentCategory | null>(null);
    const [editDocument, setEditDocument] = useState<any>(null);
    const [isEditDocMode, setIsEditDocMode] = useState(false);

    const [showDoctable, setShowDoctable] = useState(false);
    const [selectedCategoryName, setSelectedCategoryName] = useState("");
    const [documentNames, setDocumentNames] = useState<IDocumentName[]>([]);
    const [docNamesLoading, setDocNamesLoading] = useState(false);
    const [docNamesTotalCount, setDocNamesTotalCount] = useState(0);
    const [docNamesLazyParams, setDocNamesLazyParams] = useState<ILazyParams>(defaultLazyParams());

    const [employeeCategories, setEmployeeCategories] = useState<IDocumentCategory[]>([]);
    const [employeeLoading, setEmployeeLoading] = useState(false);
    const [employeeTotal, setEmployeeTotal] = useState(0);
    const [employeeLazyParams, setEmployeeLazyParams] = useState<ILazyParams>(defaultLazyParams());

    const [directorCategories, setDirectorCategories] = useState<IDocumentCategory[]>([]);
    const [directorLoading, setDirectorLoading] = useState(false);
    const [directorTotal, setDirectorTotal] = useState(0);
    const [directorLazyParams, setDirectorLazyParams] = useState<ILazyParams>(defaultLazyParams());

    const buildParams = (type: DocumentForType, lazyParams: ILazyParams) => {
        const params = new URLSearchParams();
        params.set('type', type);
        params.set('first', String(lazyParams.first));
        params.set('rows', String(lazyParams.rows));
        if (lazyParams.sortField) params.set('sortField', lazyParams.sortField);
        if (lazyParams.sortOrder) params.set('sortOrder', String(lazyParams.sortOrder));
        if (lazyParams.globalFilter) params.set('globalFilter', lazyParams.globalFilter);
        if (lazyParams.filters && Object.keys(lazyParams.filters).length) {
            params.set('filters', JSON.stringify(lazyParams.filters));
        }
        return params;
    };

    const loadEmployeeCategories = async () => {
        setEmployeeLoading(true);
        const params = buildParams('Employee', employeeLazyParams);
        const response = await fetchApi<any>(`Hrlense_Document_Category?${params.toString()}`, "GET");
        if (response) {
            setEmployeeCategories(response.data ?? response ?? []);
            setEmployeeTotal(response.totalRecords ?? response.length ?? 0);
        }
        setEmployeeLoading(false);
    };

    const loadDirectorCategories = async () => {
        setDirectorLoading(true);
        const params = buildParams('Director', directorLazyParams);
        const response = await fetchApi<any>(`Hrlense_Document_Category?${params.toString()}`, "GET");
        if (response) {
            setDirectorCategories(response.data ?? response ?? []);
            setDirectorTotal(response.totalRecords ?? response.length ?? 0);
        }
        setDirectorLoading(false);
    };

    useEffect(() => { loadEmployeeCategories(); }, [employeeLazyParams]);
    useEffect(() => { loadDirectorCategories(); }, [directorLazyParams]);

    const reloadActiveTab = () => {
        if (activeType === 'Employee') loadEmployeeCategories();
        else loadDirectorCategories();
    };

    const reloadBothTabs = () => {
        loadEmployeeCategories();
        loadDirectorCategories();
    };

    const handleAddDocumentCateogry = () => {
        setIsEditMode(false);
        setCurrentDocumentCategory({ id: 0, document_Category_Name: '', document_For: activeType });
        setDrawerOpen(true);
    };

    const handleEditDocumentCategory = (document_Category: IDocumentCategory) => {
        setIsEditMode(true);
        setCurrentDocumentCategory({
            id: (document_Category as any).id,
            document_Category_Name: document_Category.document_Category_Name,
            document_For: ((document_Category as any).document_For as DocumentForType) ?? activeType,
        });
        setDrawerOpen(true);
    };

    const handleEditDocument = (doc: any) => {
        setEditDocument(doc);
        setIsEditDocMode(true);
        setDocumentDrawerOpen(true);
    };

    const handleInputChange = (e: any) => {
        const { name, value } = e.target;
        setCurrentDocumentCategory(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async () => {
        const trimmedName = currentDocumentCategory.document_Category_Name.trim();

        if (!trimmedName) {
            addToast({
                status: "error",
                title: "Document Category Name is required",
            } as any);
            return;
        }

        const payload = {
            id: currentDocumentCategory.id,
            document_Category_Name: trimmedName,
            document_For: currentDocumentCategory.document_For,
        };

        if (isEditMode) {
            const response = await fetchApi('Hrlense_Document_Category', "PUT", payload, null, "Document Category updated successfully");
            if (response) reloadBothTabs();
        } else {
            const response = await fetchApi<IDocumentCategory>("Hrlense_Document_Category", "POST", payload, null, "Document Category added successfully");
            if (response) reloadBothTabs();
        }
        setDrawerOpen(false);
    };
    const handleToggleStatus = async (id: number) => {
        const response = await fetchApi(`Hrlense_Document_Category/togglestatus`, "PUT", null, `ID=${id}`, "Status Change successfully");
        if (response) reloadActiveTab();
    };

    const handleAddDocument = (selectedCategory: IDocumentCategory) => {
        setSelectedCategoryForDocument(selectedCategory);
        setDocumentDrawerOpen(true);
    };

    const handleshowDocumentName = (category: IDocumentCategory) => {
        setSelectedCategoryName(category.document_Category_Name);
        setSelectedCategoryForDocument(category);
        setDocNamesLazyParams(defaultLazyParams());
        setShowDoctable(true);
    };

    const handleToggleDocumentStatus = async (id: number) => {
        const response = await fetchApi(`Hrlense_Document_Category/togglestatus/document`, "PUT", null, `ID=${id}`, "Status Change successfully");
        if (response) refreshDocumentList();
    };

    const loadDocumentNames = async () => {
        if (!selectedCategoryForDocument) return;
        setDocNamesLoading(true);
        const params = new URLSearchParams();
        params.set('category_Id', String(selectedCategoryForDocument.id));
        params.set('first', String(docNamesLazyParams.first));
        params.set('rows', String(docNamesLazyParams.rows));
        if (docNamesLazyParams.sortField) params.set('sortField', docNamesLazyParams.sortField);
        if (docNamesLazyParams.sortOrder) params.set('sortOrder', String(docNamesLazyParams.sortOrder));
        if (docNamesLazyParams.globalFilter) params.set('globalFilter', docNamesLazyParams.globalFilter);
        if (docNamesLazyParams.filters && Object.keys(docNamesLazyParams.filters).length) {
            params.set('filters', JSON.stringify(docNamesLazyParams.filters));
        }
        const response = await fetchApi<any>(`Hrlense_Document_Category/getdocument?${params.toString()}`, "GET");
        if (response) {
            setDocumentNames(response.data ?? response ?? []);
            setDocNamesTotalCount(response.totalRecords ?? response.length ?? 0);
        }
        setDocNamesLoading(false);
    };

    useEffect(() => {
        if (showDoctable && selectedCategoryForDocument) loadDocumentNames();
    }, [docNamesLazyParams, showDoctable, selectedCategoryForDocument?.id]);

    const refreshDocumentList = async () => { await loadDocumentNames(); };

    const renderCategoryTable = (
        rows: IDocumentCategory[], loading: boolean, total: number,
        lazyParams: ILazyParams, setLazyParams: (p: ILazyParams) => void, preferenceKey: string
    ) => (
        <CustomTables<IDocumentCategory>
            value={rows} loading={loading} emptyMessage="No document categories found." preferenceKey={preferenceKey}
            showGlobalSearch={false} showToolbar={true}
            lazy lazyParams={lazyParams} onLazyParamsChange={setLazyParams} totalRecords={total} showPagination
            rowsPerPageOptions={[20, 100, 200, 500]} maxTableHeight={null}
        >
            <Column header="S. No" body={(_, index) => lazyParams.first + index + 1} />
            <Column header="Document Category Name" field="document_Category_Name" sortable filterable filterType="text"
                body={(dc: IDocumentCategory) => (
                    <Text as="span" cursor="pointer" color="#006838" _hover={{ textDecoration: "underline" }}
                        onClick={() => handleshowDocumentName(dc)}>
                        {dc.document_Category_Name}
                    </Text>
                )} />
            <Column header="Status" field="status" filterable filterType="boolean"
                body={(dc: any) => (
                    <Text as="span" onClick={() => handleToggleStatus(dc.id)} cursor="pointer" className="font-poppins text_sm text_medium text-center" color={dc.status ? "green.600" : "red.600"} _hover={{ textDecoration: "underline" }}>
                        {dc.status ? "Active" : "Inactive"}
                    </Text>
                )} />
            <Column header="Actions" frozen="right" body={(dc: any) => (
                <Flex align="center" gap={1}>
                    <Tooltip label="Edit Document Category" hasArrow>
                        <IconButton aria-label="Edit" icon={<EditIcon />} size="sm" colorScheme="orange" variant="ghost" onClick={() => handleEditDocumentCategory(dc)} />
                    </Tooltip>
                    <Tooltip label="Add Document Name" hasArrow placement="top">
                        <IconButton aria-label="Add Document Name" icon={<AddIcon />} size="sm" colorScheme="green" variant="ghost" onClick={() => handleAddDocument(dc)} />
                    </Tooltip>
                </Flex>
            )} />
        </CustomTables>
    );

    return (
        <MyDiv>
            <Box position="relative" minH="300px">
                <Flex className="page_heading flex_header">
                    <Text className="font-poppins text_semibold text_3xl">Document Category</Text>
                    <Flex gap={2}>
                        <CustomButton title="Add Document Category" className='btn font-poppins text_sm text_medium' rightIcon={<Image src={PlusIcon} className='logo' />} onClick={handleAddDocumentCateogry} />
                    </Flex>
                </Flex>

                <Tabs index={activeTab} onChange={setActiveTab} colorScheme="green" mt={2}>
                    <TabList>
                        <Tab className="font-poppins text_sm text_medium">Employee Document</Tab>
                        <Tab className="font-poppins text_sm text_medium">Director Document</Tab>
                    </TabList>
                    <TabPanels>
                        <TabPanel px={0}>
                            <Grid className='grid_container'>
                                <GridItem colSpan={12}>
                                    {renderCategoryTable(employeeCategories, employeeLoading, employeeTotal, employeeLazyParams, setEmployeeLazyParams, "employeeDocumentCategoryTable")}
                                </GridItem>
                            </Grid>
                        </TabPanel>
                        <TabPanel px={0}>
                            <Grid className='grid_container'>
                                <GridItem colSpan={12}>
                                    {renderCategoryTable(directorCategories, directorLoading, directorTotal, directorLazyParams, setDirectorLazyParams, "directorDocumentCategoryTable")}
                                </GridItem>
                            </Grid>
                        </TabPanel>
                    </TabPanels>
                </Tabs>

                <Modal isOpen={showDoctable} onClose={() => setShowDoctable(false)} size="6xl" isCentered>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader>{selectedCategoryName}</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody>
                            <CustomTables<IDocumentName>
                                value={documentNames} loading={docNamesLoading} emptyMessage="No records found" preferenceKey="documentNamesTable"
                                lazy lazyParams={docNamesLazyParams} onLazyParamsChange={setDocNamesLazyParams} totalRecords={docNamesTotalCount} showPagination
                                rowsPerPageOptions={[20, 100, 200, 500]} maxTableHeight={null} showGlobalSearch={false} showToolbar={true}
                            >
                                <Column header="S. No" body={(_, index) => docNamesLazyParams.first + index + 1} />
                                <Column header="Document Name" field='document_Name_Title' sortable filterable filterType="text" />
                                <Column header="Country" field='country' sortable filterable filterType="text" />
                                <Column header="Expire" field="expire" filterable filterType="boolean" body={(row: any) => (row.expire ? "Yes" : "No")} />
                                <Column header="Document Number" field="document_Number" filterable filterType="boolean" body={(row: any) => (row.document_Number ? "Yes" : "No")} />
                                <Column header="Is Required" body={(row: any) => (row.is_Required ? "Yes" : "No")} />
                                <Column header="Country Name" body={(row: any) => (row.country === 0 ? "All Country" : row.country_Name)} />
                                <Column header="Status" field="status" filterable filterType="boolean"
                                    body={(row: any) => (
                                        <Text as="span" onClick={() => handleToggleDocumentStatus(row.id)} cursor="pointer" className="font-poppins text_sm text_medium text-center" color={row.status ? "green.600" : "red.600"} _hover={{ textDecoration: "underline" }}>
                                            {row.status ? "Active" : "Inactive"}
                                        </Text>
                                    )} />
                                <Column header="Actions" frozen="right" body={(row: any) => (
                                    <Tooltip label="Edit Document" hasArrow>
                                        <IconButton aria-label="Edit" icon={<EditIcon />} size="sm" colorScheme="orange" variant="ghost" onClick={() => handleEditDocument(row)} />
                                    </Tooltip>
                                )} />
                            </CustomTables>
                        </ModalBody>
                    </ModalContent>
                </Modal>

                <Drawer isOpen={DrawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="sm">
                    <DrawerOverlay />
                    <DrawerContent>
                        <DrawerCloseButton />
                        <DrawerHeader borderBottomWidth="1px">
                            {isEditMode ? 'Edit Document Category' : 'Add Document Category'}
                        </DrawerHeader>
                        <DrawerBody display="flex" flexDirection="column" justifyContent="space-between" height="100%">
                            <Box py={4}>

                                <FormControl mb={4} isRequired>
                                    <FormLabel>Document For</FormLabel>
                                    <Select name="document_For" value={currentDocumentCategory.document_For} onChange={handleInputChange}
                                    >
                                        <option value="Employee">Employee</option>
                                        <option value="Director">Director</option>
                                    </Select>
                                </FormControl>
                                <FormControl mb={4} isRequired isInvalid={!currentDocumentCategory.document_Category_Name.trim()}>
                                    <FormLabel>Document Category Name</FormLabel>
                                    <Input name="document_Category_Name" value={currentDocumentCategory.document_Category_Name} onChange={handleInputChange} placeholder="Enter document category name"
                                    />
                                </FormControl>


                            </Box>
                            <Flex justify="flex-end" mt={4} gap={2}>
                                <Button className="font-poppins text_sm text_medium" onClick={() => setDrawerOpen(false)} style={{ backgroundColor: '#D92F34', color: 'white' }}>Cancel</Button>
                                <Button onClick={handleSubmit} className="font-poppins text_sm text_medium" style={{ backgroundColor: '#006838', color: 'white' }}
                                    isDisabled={!currentDocumentCategory.document_Category_Name.trim()}
                                >
                                    {isEditMode ? "Update Document Category" : "Add document category"}
                                </Button>
                            </Flex>
                        </DrawerBody>
                    </DrawerContent>
                </Drawer>
            </Box>

            <DocumentName isOpen={documentDrawerOpen} onClose={() => { setDocumentDrawerOpen(false); setIsEditDocMode(false); setEditDocument(null); }}
                selectedCategory={selectedCategoryForDocument} editData={editDocument} isEditMode={isEditDocMode}
                afterSave={() => { refreshDocumentList(); reloadBothTabs(); }}
            />
        </MyDiv>
    )
}

export default MasterDepartment;